import LegOriginDestination from '@/components/purchase/checkout/LegOriginDestination';
import { ReservedSeats } from '@/components/purchase/checkout/seat-selection/ReservedSeats';
import type { LegInfo } from '@/hooks/useSeatSelectionLegs';
import { TransText, type TransTextKeys } from '@/i18n/trans/text';
import { cn } from '@/utils/cn';
import { Icons, Typography } from '@fleet/webshop-ui';

interface TripSectionProps {
  title: TransTextKeys;
  legs: Array<LegInfo>;
}

export const TripSection = ({ title, legs }: TripSectionProps) => (
  <div className="flex-1">
    <Typography variant="body1-bold" className="pb-4">
      <TransText i18nKey={title} />
    </Typography>
    <div className="flex flex-col gap-5">
      {legs.map((leg, key) => (
        <div
          key={key}
          className={cn({
            'border-b border-neutral-pale pb-4': key < legs.length - 1,
          })}
        >
          <LegOriginDestination
            origin={leg.originStop?.name ?? ''}
            destination={leg.destinationStop?.name ?? ''}
            ptMode={leg.ptMode}
          />
          {!leg.noSeatSelection ? (
            <ReservedSeats leg={leg} />
          ) : (
            <div className="my-4 flex items-center gap-2 pl-7 text-neutral">
              <Icons.seat className="h-4 w-4" />
              <Typography variant="body2">
                <TransText i18nKey="seatReservationNotAvailable" />
              </Typography>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);
